import React, { useState } from "react";
import { FileText, ChevronDown, ChevronUp, Loader2 } from "lucide-react";
import { RayicAccordion } from "./RayicShared";
import { tl } from "./rayicUtils";

export default function RayicBelgeAnalizPanel({ belge, hamOzet, parseKaynak, fiyatBekliyor, fiyatBusy }) {
    const [hamAcik, setHamAcik] = useState(false);
    if (!belge) return null;

    const parcalar = belge.parcalar || [];

    return (
        <div className="rounded-xl border border-cyan-500/25 bg-cyan-500/5 p-3 space-y-2">
            <div className="flex flex-wrap items-center gap-2">
                <FileText className="h-4 w-4 text-cyan-400" />
                <span className="text-sm font-medium text-white">Ekspertiz okuma sonucu</span>
                {parseKaynak ? (
                    <span className="text-[10px] px-2 py-0.5 rounded-full border border-cyan-500/30 text-cyan-300">
                        {parseKaynak}
                    </span>
                ) : null}
                {fiyatBusy ? (
                    <span className="inline-flex items-center gap-1 text-[10px] text-amber-300 ml-auto">
                        <Loader2 className="h-3 w-3 animate-spin" />
                        Fiyat taraması…
                    </span>
                ) : fiyatBekliyor ? (
                    <span className="text-[10px] text-slate-500 ml-auto">Fiyat taraması bekliyor</span>
                ) : null}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs">
                <div>
                    <div className="text-[9px] uppercase text-slate-500">Marka / Model</div>
                    <div className="text-white">
                        {belge.marka || "—"} {belge.model || ""}
                    </div>
                </div>
                <div>
                    <div className="text-[9px] uppercase text-slate-500">Plaka</div>
                    <div className="text-white">{belge.plaka || "—"}</div>
                </div>
                <div>
                    <div className="text-[9px] uppercase text-slate-500">Toplam tutar</div>
                    <div className="text-emerald-300 font-semibold">{tl(belge.toplam_tutar)}</div>
                </div>
                <div>
                    <div className="text-[9px] uppercase text-slate-500">Parça satırı</div>
                    <div className="text-white">{parcalar.length}</div>
                </div>
            </div>

            {belge.tespit_ozeti ? (
                <p className="text-[11px] text-slate-400">{belge.tespit_ozeti}</p>
            ) : null}

            {parcalar.length ? (
                <RayicAccordion title="Okunan parça satırları" badge={parcalar.length} defaultOpen>
                    <div className="overflow-x-auto max-h-48 overflow-y-auto">
                        <table className="w-full text-[11px]">
                            <thead>
                                <tr className="text-slate-500 border-b border-white/5">
                                    <th className="text-left py-1 pr-2">Parça</th>
                                    <th className="text-left py-1 pr-2">İşlem</th>
                                    <th className="text-right py-1">Tutar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {parcalar.map((p, i) => (
                                    <tr key={`bp-${i}`} className="border-b border-white/5">
                                        <td className="py-1 pr-2 text-slate-200">{p.parca_adi || "—"}</td>
                                        <td className="py-1 pr-2 text-slate-500">{p.islem_tipi || "—"}</td>
                                        <td className="py-1 text-right text-slate-300">{tl(p.tutar)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </RayicAccordion>
            ) : null}

            {hamOzet ? (
                <div>
                    <button
                        type="button"
                        onClick={() => setHamAcik((v) => !v)}
                        className="inline-flex items-center gap-1 text-[10px] text-slate-500 hover:text-slate-300"
                    >
                        {hamAcik ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
                        Ham metin özeti
                    </button>
                    {hamAcik ? (
                        <pre className="mt-1 text-[10px] text-slate-500 whitespace-pre-wrap max-h-32 overflow-y-auto bg-black/20 rounded p-2">
                            {hamOzet}
                        </pre>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
